import {AppState} from "../store";

export const getSettlementPageFilter = (state: AppState) => state.settlementPage.filter
